(() => {
  if (window.TortliCartDiscounts) return;
  window.TortliCartDiscounts = true;
  const errorMessage = document.querySelector('script[data-cart-discounts-error]')?.dataset.cartDiscountsError || '';
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-cart-discount-form]');
    if (!form) return;
    event.preventDefault();
    const code = new FormData(form).get('discount')?.toString().trim();
    if (!code) return;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.routes?.cart_url || '/cart')}`);
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-discount-remove]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    const targets = [
      {id:'main-cart-items', section:document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items', selector:'.js-contents'},
      {id:'main-cart-footer', section:document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer', selector:'#main-cart-footer'},
      {id:'cart-icon-bubble', section:'cart-icon-bubble', selector:'.shopify-section'},
    ];
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({discount:'',sections:targets.map(target=>target.section),sections_url:window.location.pathname}),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || errorMessage);
      for (const target of targets) {
        const html = state.sections?.[target.section];
        if (!html) continue;
        const source = new DOMParser().parseFromString(html,'text/html').querySelector(target.selector);
        const section = document.getElementById(target.id);
        const destination = section?.querySelector(target.selector) || section;
        if (source && destination) destination.innerHTML = source.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('tortli:cart-updated'));
      if (window.PUB_SUB_EVENTS?.cartUpdate && typeof window.publish === 'function') window.publish(window.PUB_SUB_EVENTS.cartUpdate,{source:'tortli-cart-discount',cartData:state});
    } catch (error) {window.alert(error.message);}
    finally {button.disabled=false;button.removeAttribute('aria-busy');}
  });
})();
